export const normalizeBanner = nodes =>
  nodes.map(({ id, properties, analytics }) => ({
    actions: properties?.actions,
    analytics,
    id,
    msg: properties?.body
      ?.replace(/data-id/g, 'data-analytics-action-id')
      ?.replace(/(target="_blank")/g, '$1 rel="noopener"'),
    title: properties?.title,
  }));
